import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/core/get/get.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/manipulation/remove/remove.js";

export default obj => {
	if (obj.length) {
		const form = $("form", obj);

		// record which action button was pressed
		let button;
		$("button[name=action]", form).on("click", function () {
			button = this.value;
		});

		form.on("submit", e => {
			if (button) {

				// make fetch request to set cookie preferences
				const params = new FormData(form.get(0));
				params.set("action", button);
				const url = (form.attr("action") || "") + "?" + new URLSearchParams(params);
				fetch(url, {headers: {accept: "application/json"}}).then(() => {

					// notify google tag manager
					obj.trigger("cookies.updated");
				});

				// hide then remove from DOM, otherwise makes everything underneath unclickable
				obj
					.addClass(obj.attr("class").split(" ")[0] + "--hide")
					.on("transitionend", () => obj.remove());

				// prevent default submit action
				e.preventDefault();
			}
		});
	}
};
